import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import GalleryForm, { GALLERY_BATCH_SIZE } from "./GalleryForm";

export default function AddGallery() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [status, setStatus] = useState("0");
  const [images, setImages] = useState(Array(GALLERY_BATCH_SIZE).fill(null));
  const [previews, setPreviews] = useState(Array(GALLERY_BATCH_SIZE).fill(""));
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    ApiRequest("GET", ApiEndpoints.galleryCategory.list)
      .then((response) =>
        setCategories((response.gallery_categories || []).filter((category) => category.status === "0"))
      )
      .catch((error) => toast.error(error.response?.data?.message || "Unable to load categories."));
  }, []);

  const handleImageChange = (index, event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setImages((current) => current.map((item, itemIndex) => itemIndex === index ? file : item));
    setPreviews((current) => current.map((preview, itemIndex) =>
      itemIndex === index ? URL.createObjectURL(file) : preview
    ));
  };

  const handleAddBatch = () => {
    if (!images.every(Boolean)) {
      toast.error("Complete all 7 images in the current set first.");
      return;
    }
    setImages((current) => [...current, ...Array(GALLERY_BATCH_SIZE).fill(null)]);
    setPreviews((current) => [...current, ...Array(GALLERY_BATCH_SIZE).fill("")]);
  };

  const handleRemoveBatch = (batchIndex) => {
    const start = batchIndex * GALLERY_BATCH_SIZE;
    previews.slice(start, start + GALLERY_BATCH_SIZE).forEach((preview) => {
      if (preview?.startsWith("blob:")) URL.revokeObjectURL(preview);
    });
    setImages((current) => current.filter((_, index) =>
      index < start || index >= start + GALLERY_BATCH_SIZE
    ));
    setPreviews((current) => current.filter((_, index) =>
      index < start || index >= start + GALLERY_BATCH_SIZE
    ));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!categoryId) return toast.error("Please select a gallery category.");
    if (images.length < GALLERY_BATCH_SIZE || images.length % GALLERY_BATCH_SIZE !== 0 || images.some((image) => !image)) {
      return toast.error("Every image set must contain exactly 7 images.");
    }
    const payload = new FormData();
    payload.append("category_id", categoryId);
    payload.append("status", status);
    payload.append("total_images", String(images.length));
    images.forEach((image, index) => payload.append(`image_${index}`, image));

    setSaving(true);
    try {
      const response = await ApiRequest("POST", ApiEndpoints.gallery.create, payload);
      toast.success(response.message);
      navigate("/gallery");
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to create gallery.");
    } finally {
      setSaving(false);
    }
  };

  const pagename = { name: "Gallery Management", user: "Admin", innerpage: "Gallery / Add" };
  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <GalleryForm formId="galleryAdd" categories={categories} categoryId={categoryId}
          setCategoryId={setCategoryId} status={status} setStatus={setStatus}
          images={images} previews={previews} onImageChange={handleImageChange}
          onAddBatch={handleAddBatch} onRemoveBatch={handleRemoveBatch}
          onSubmit={handleSubmit} saving={saving} />
        <button type="submit" form="galleryAdd" className="default-btn" disabled={saving}>
          {saving ? "Saving..." : "Publish"} <span></span>
        </button>
      </div>
    </>
  );
}
